import { render, staticRenderFns } from "./SubmitTask.vue?vue&type=template&id=7be635e3&"
import script from "./SubmitTask.vue?vue&type=script&lang=js&"
export * from "./SubmitTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports